module.exports = __webpack_public_path__ + "img/teva.d04fc9c0.png";